import { FormLabel } from "@chakra-ui/react";
/**
 * This file is to standardise the default font etc for labels 
 */
export default function EsgFormLabel({
	htmlFor, children, color, fontSize = "sm",
	whiteSpace = "nowrap", marginBlockEnd = "1", blockSize = "5",
	...rest }) 
{
	return (
		<FormLabel
			htmlFor={htmlFor}
			fontSize={fontSize}
			whiteSpace={whiteSpace}
			marginBlockEnd={marginBlockEnd}
			blockSize={blockSize}
			color={color}
			isTruncated
			title={typeof children === "string" ? children : ""}
			{...rest}
		>
			{children}
		</FormLabel>
	);
}